import type { BoxProps as MuiBoxProps } from '@mui/material/Box/Box';
import MuiBox from '@mui/material/Box/Box';

export type BoxProps = MuiBoxProps;

export const Box = MuiBox;
